export default class CategoryPage extends HTMLDivElement {

    constructor() {
        super();
        this.optionBtn = this.querySelector('.btn-option');
        this.mainRight = this.querySelector('.main-right');
        this.asideLeft = this.querySelector('.aside-left');
    }

    connectedCallback() {

        this.optionBtn.addEventListener('click',e => {

           e.preventDefault();

           console.log('ok');
           if(this.mainRight.classList.contains('main-right-notfull')){
               this.mainRight.classList.remove('main-right-notfull');
           } else {
               this.mainRight.classList.add('main-right-notfull');
           }

           if(this.asideLeft.style.display === "none"){
               this.asideLeft.style.display = "block";
           } else {
               this.asideLeft.style.display = "none";
           }
        });
    }

}


// WEBPACK FOOTER //
// ./resources/assets/js/front/components/CategoryPage.js